import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import notify from "../../ReusableComponents/ToastifyAlerts";
const ExamTimeCal = (props) => {

  // const APIURL = ;
  const APIKEY = process.env.REACT_APP_XApiKey;
  const navigate = useNavigate();
  const AssessmentTimeLeft = process.env.REACT_APP_API_BASE_URL + "/Assessment/GetAssessmentTimeLeft";

  const [seconds, setSeconds] = useState();
  const [isActive, setIsActive] = useState(true);
  const gettime = async () => {
    await axios
      .get(AssessmentTimeLeft + `?ContestCreationId=${props.contestCreationID}&UserId=${props.UserId}&AssessmentType=${props.AssessmenType}&Subject=${props.SubName}&Grade=${props.Grade}`, { headers: { XApiKey: APIKEY } })
      .then((res) => {
        if (res.data.startsWith("-")) {notify("Your assessment time has expired. You will be redirected to the results page.", "warning");
          navigate("/Student/Results", { replace: true });
        } else {
          convertToSeconds(res.data);
        }
      })
      .catch((err) => { console.log(err); });
  };
  const convertToSeconds = (timeStr) => {
    const parts = timeStr.split(":").map(Number);
    let totalSeconds = 0;

    if (parts.length === 3) {
      // HH:MM:SS format
      const [hours, minutes, secs] = parts;
      totalSeconds = hours * 3600 + minutes * 60 + secs;
    } else if (parts.length === 2) {
      // MM:SS or HH:MM format
      const [part1, part2] = parts;
      if (part1 >= 60) {
        // Assume HH:MM format
        totalSeconds = part1 * 3600 + part2 * 60;
      } else {
        // Assume MM:SS format
        totalSeconds = part1 * 60 + part2;
      }
    }
    TimeCal(totalSeconds);
  };
  let interval = null;
  const TimeCal = (e) => {
    setSeconds(e);
    if (e > 0) {
      // Set up an interval to decrease the time every second 
      interval = setInterval(() => {
        setSeconds((prevSeconds) => (prevSeconds > 0 ? prevSeconds - 1 : 0));
      }, 1000);

      // Clear the interval when the component unmounts
      return () => clearInterval(interval);
    } else if (e <= 0) {
      // sessionStorage.clear();
      // localStorage.clear();
      // navigate("/Student/Results", { replace: true });
      // window.location.reload();

    }

  };

  useEffect(() => {
    if (localStorage.getItem("ResumeId") === "Resume") { gettime(); }
    else { TimeCal(props.duration * 60); }
    return () => { clearInterval(interval); };
  }, []);

  if (isActive && (seconds === 0 || seconds === "00:00")) {

    if (props.FinialSubject) {
      setIsActive(!isActive);
      if (!localStorage.getItem("timeupAlertShown")) {
        localStorage.setItem("timeupAlertShown", true);
        alert(`Oops, the assessment time is up, and ${props.SubName} Assessment has been submitted automatically. Assessment Feedback form will be loaded shortly…`);
        props.Timeup();
      }
    } else {
      props.ConformModelCLose(true);
    }
  }


  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    if (hours > 0) {
      let Rtime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
      props.Gtime(Rtime);
      return Rtime;
    } else {
      let Rtime = `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
      props.Gtime(Rtime);
      return Rtime;
    }
  };
  return (
    <>
      {seconds > 0 ? formatTime(seconds) : "Loading"}
    </>
  );
};

export default ExamTimeCal;







// import React, {  useState, useEffect } from "react";
// import axios from "axios";

// const ExamTimeCal = (props) => {

//   const APIURL = process.env.REACT_APP_API_BASE_URL;
//   const APIKEY = process.env.REACT_APP_XApiKey;

//   const AssessmentTimeLeft = APIURL + "/Assessment/GetAssessmentTimeLeft";

//   const [seconds, setSeconds] = useState(() => {
//     if (localStorage.getItem("ResumeId") === "Resume") {
//       return " ";
//     } else {
//       return props.duration * 60;
//     }
//   });
//   const [isActive, setIsActive] = useState(true);

//   useEffect(() => {
//     let interval = null;
//     if (localStorage.getItem("ResumeId") === "Resume") {
//       interval = setInterval(() => {
//         gettime();
//       }, 1000);
//     } else {
//       if (isActive && seconds > 0) {
//         interval = setInterval(() => {
//           setSeconds((prevSeconds) => {
//             const newSeconds = prevSeconds - 1;
//            // props.Gtime(newSeconds);
//             return newSeconds;
//           });
//         }, 1000);
//       } else {
//         clearInterval(interval);
//       }
//     }
//     return () => {
//       clearInterval(interval);
//     };
//   }, [isActive]);

//   if (isActive && (seconds === 0 || seconds === "00:00")) {


//     if (props.SubName.toLowerCase() === props.LastSubject.toLowerCase()) {
//       setIsActive(!isActive);
//       if (!localStorage.getItem("timeupAlertShown")) {
//         localStorage.setItem("timeupAlertShown", true);
//         alert(process.env.REACT_APP_ASSESSMENTTIMEUP);
//         props.Timeup();
//       }
//     }
//     else{
//       props.ConformModelCLose(true);
//     }
//   }

//   const gettime = async() => {
//    await axios
//       .get(
//         AssessmentTimeLeft +
//           `?ContestCreationId=${props.contestCreationID}&UserId=${props.UserId}&AssessmentType=${props.AssessmenType}&Subject=${props.SubName}&Grade=${props.Grade}`
//           ,{headers: { XApiKey: APIKEY }})
//       .then((res) => {
//         props.Gtime(res.data);
//         setSeconds(res.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };


//   //FormateTimer 00:00:00
//   const formatTime = (time) => {
//     const minutes = Math.floor(time / 60);
//     const seconds = time % 60;
//     let Rtime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
//     props.Gtime(Rtime);
//     return Rtime;
//   };

//   return (
//     <>
//         {localStorage.getItem("ResumeId") === "Resume" ? seconds : formatTime(seconds)}
//     </>
//   );
// };

// export default ExamTimeCal;
